import React from 'react'

const CustomArrowRightIcon = (
  <svg
    aria-hidden="true"
    width="14"
    height="21"
    viewBox="0 0 14 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 2L10.5 10.5L2 19" stroke="black" strokeWidth="4" />
  </svg>
)

export default CustomArrowRightIcon
